import moment from 'moment';

import {DATE_FOR_REQUEST} from 'shared/constants/date-format';

import {IFactorInfluenceInfoItemResponse, IMacroEconomicItemForm} from '../model/types';

export const mapResponseToFormData = (data: IFactorInfluenceInfoItemResponse): IMacroEconomicItemForm => ({
    reportingDate: data?.reportingDate || undefined,
    registryMspId: data?.registryMsp?.id,
    backboneEnterpriseId: data?.backboneEnterprise?.id,
    effectInfluenceId: data?.effectInfluence?.id,
    suppliesDifficultId: data?.suppliesDifficult?.id,
    equipmentDifficultId: data?.equipmentDifficult?.id,
    maintenanceDifficultId: data?.maintenanceDifficult?.id,
    priceId: data?.price?.id,
    pricePercent: data?.pricePercent,
    costImportId: data?.costImport?.id,
    costImportPercent: data?.costImportPercent,
    costLogisticId: data?.costLogistic?.id,
    costLogisticPercent: data?.costLogisticPercent,
    prodVolumeId: data?.prodVolume?.id,
    prodVolumePercent: data?.prodVolumePercent,
    financCostId: data?.financCost?.id,
    financCostPercent: data?.financCostPercent,
    staffId: data?.staff?.id,
    staffPercent: data?.staffPercent,
    wageFundId: data?.wageFund?.id,
    wageFundPercent: data?.wageFundPercent,
    homeRevenueId: data?.homeRevenue?.id,
    homeRevenuePercent: data?.homeRevenuePercent,
    foreignRevenueId: data?.foreignRevenue?.id,
    foreignRevenuePercent: data?.foreignRevenuePercent,
    creditorDebtId: data?.creditorDebt?.id,
    creditorDebtPercent: data?.creditorDebtPercent,
    debtorDebtId: data?.debtorDebt?.id,
    debtorDebtPercent: data?.debtorDebtPercent,
    factors:
        data.factors && data.factors.length > 0
            ? data.factors.map((factor) => ({
                  ...factor,
                  factorLevelId: factor.factorLevel?.id,
                  factorTypeCodeId: factor.factorTypeCode?.id,
              }))
            : [],
});

const formatDateForRequest = (date: string | undefined | null): string | undefined => {
    if (!date) return undefined;

    const momentDate = moment(date);
    if (!momentDate.isValid()) return undefined;

    return momentDate.format(DATE_FOR_REQUEST);
};

export const mapFormDataToRequest = (fieldsData: IMacroEconomicItemForm) => ({
    reportingDate: fieldsData?.reportingDate,
    registryMspId: fieldsData?.registryMspId,
    backboneEnterpriseId: fieldsData?.backboneEnterpriseId,
    effectInfluenceId: fieldsData?.effectInfluenceId,
    suppliesDifficultId: fieldsData?.suppliesDifficultId,
    equipmentDifficultId: fieldsData?.equipmentDifficultId,
    maintenanceDifficultId: fieldsData?.maintenanceDifficultId,
    priceId: fieldsData?.priceId,
    pricePercent: fieldsData?.pricePercent,
    costImportId: fieldsData?.costImportId,
    costImportPercent: fieldsData?.costImportPercent,
    costLogisticId: fieldsData?.costLogisticId,
    costLogisticPercent: fieldsData?.costLogisticPercent,
    prodVolumeId: fieldsData?.prodVolumeId,
    prodVolumePercent: fieldsData?.prodVolumePercent,
    financCostId: fieldsData?.financCostId,
    financCostPercent: fieldsData?.financCostPercent,
    staffId: fieldsData?.staffId,
    staffPercent: fieldsData?.staffPercent,
    wageFundId: fieldsData?.wageFundId,
    wageFundPercent: fieldsData?.wageFundPercent,
    homeRevenueId: fieldsData?.homeRevenueId,
    homeRevenuePercent: fieldsData?.homeRevenuePercent,
    foreignRevenueId: fieldsData?.foreignRevenueId,
    foreignRevenuePercent: fieldsData?.foreignRevenuePercent,
    creditorDebtId: fieldsData?.creditorDebtId,
    creditorDebtPercent: fieldsData?.creditorDebtPercent,
    debtorDebtId: fieldsData?.debtorDebtId,
    debtorDebtPercent: fieldsData?.debtorDebtPercent,
    factors: (fieldsData?.factors ?? []).map((factor) => ({
        ...factor,
        prods: factor?.prods || [],
        publicDate: formatDateForRequest(factor?.publicDate),
        effectiveDate: formatDateForRequest(factor?.effectiveDate),
        startDate: formatDateForRequest(factor?.startDate),
        cancelDate: formatDateForRequest(factor?.cancelDate),
    })),
});
